import calculateCashConsiderationValues from './calculate-cash-consideration-values';
import type { ConsiderationType } from 'further-types/exit';
import type { UseFormSetValue } from 'react-hook-form';
import type { ExitDetailsFormValues } from './index';

type HandleCashConsiderationParams = {
  changedField: 'perShare' | 'total';
  newValue?: string;
  considerationType: ConsiderationType | undefined;
  sharesToBeSold: number;
  isCalculating: React.MutableRefObject<boolean>;
  setValue: UseFormSetValue<ExitDetailsFormValues>;
};

export const handleCalculateCashConsiderationValuesTaxable = ({
  changedField,
  newValue,
  considerationType,
  sharesToBeSold,
  isCalculating,
  setValue,
}: HandleCashConsiderationParams) => {
  calculateCashConsiderationValues({
    changedField,
    newValue,
    considerationType,
    sharesToBeSold,
    isCalculating,
    setValue,
    fieldPrefix: 'taxableValue',
  });
};

export const handleCalculateCashConsiderationValuesReceived = ({
  changedField,
  newValue,
  considerationType,
  sharesToBeSold,
  isCalculating,
  setValue,
}: HandleCashConsiderationParams) => {
  calculateCashConsiderationValues({
    changedField,
    newValue,
    considerationType,
    sharesToBeSold,
    isCalculating,
    setValue,
    fieldPrefix: 'receivedValue',
  });
};
